
import React, { Component } from 'react';
import { createClient } from 'contentful';
import logo from './img/logo.svg';
import Home from './Home';

class Posts extends Component {
    constructor(props) {
      super(props);
      this.state = { 
        isLoaded: false, 
        posts: null, 
        entryPost: null,
        catMenu: null,
        contactDetails: null
      };

      this.loadingScreen = this.loadingScreen.bind(this);
      this.renderPosts = this.renderPosts.bind(this);
      this.findWithAttr = this.findWithAttr.bind(this);
    }
 
    componentWillMount() {
        const client = createClient({
          space: process.env.REACT_APP_SPACE_ID,
          accessToken: process.env.REACT_APP_ACCESS_TOKEN
        });
    
        client
          .getContentTypes()
          .then(response => {
            const postType = response.items.find(item => item.name === 'Project');
            return postType.sys.id;
          })
          .then(id => {
            client
              .getEntries({
                content_type: id
              })
              .then(response => {
                this.setState({
                  posts: response.items, 
                  entryPost: this.findWithAttr(response.items, 'fields', 'slug', this.props.match.params.slug)
                })
                this.removeLoadingScreen();
              })
              .catch(console.error);
          })
          .catch(console.error);

        client
        .getContentType('categoryMenu')
        .then(response => {
          this.setState({
             catMenu: response.fields[1].items.validations[0].in 
          });
        })

        client
        .getContentTypes()
        .then(response => {
          const postType = response.items.find(item => item.name === 'Contact');
          return postType.sys.id;
        })
        .then(id => {
          client
            .getEntries({
              content_type: id
            })
            .then(response => {
              this.setState({
                contactDetails: response.items[0].fields
              })
            })
            .catch(console.error);
        })
        .catch(console.error);

    }

    removeLoadingScreen(){
      setTimeout(() => {
        this.setState({
          isLoaded: true
        })
      }, 2000)
    }


    findWithAttr(array, attr, second, value) {
      for(var i = 0; i < array.length; i += 1) {
          if(array[i][attr][second] === value) {
            // console.log(value, i)
              return i;
          }
      }
      return 1;
    }

    renderPosts() {
      if(this.state.posts === null) {
        return null;
      } else {   
        return (
            <Home posts={this.state.posts} entryPost={this.state.entryPost} catMenu={this.state.catMenu} contact={this.state.contactDetails} {...this.props}/>
        );
      }
    }

    loadingScreen(){
      return(
        <div id="content">
          <div id="loading-logo" className="fixed-center" style={{position: 'fixed', top: '50%', left: '50%', width: '35%', height: '0', paddingBottom:'29%', transform: 'translateX(-50%) translateY(-50%)'}}>
            <img src={logo} alt="Thomas Petherick" />
          </div>
        </div>
      )
    }

    render(){
       return (
        <div id="wrapper">
          {this.state.isLoaded ? this.renderPosts() : this.loadingScreen() }
        </div>
      )
    }
}

export default Posts;


// WEBPACK FOOTER //
// ./src/Posts.js